import { useRouter } from 'next-translate-routes/router';
import { useEffect, useState } from 'react';

import { BestRatesList } from '@/components/BestRatesList/BestRatesList';
import { useApi } from '@/contexts/ApiContext';
import { useCmsContent } from '@/contexts/CmsContentContext';
import { MapDepositsFromServer } from '@/services/supabase';
import type { IRateInBestRatesProps } from '@/types';
import { COUNTRIES_PATHS } from '@/utils/countries';
import { termKeys } from '@/utils/termKeys';

export const BestRatesListWrapper = () => {
  const { country } = useCmsContent();
  const { getDepositsListRequest } = useApi();
  const { locale } = useRouter();
  const [fixedDeposits, setFixedDeposits] = useState<IRateInBestRatesProps[]>(
    [],
  );

  const fetchRates = async () => {
    try {
      const { data: oneYearDepositsBestRate } = await getDepositsListRequest(
        locale || 'en',
        {
          page: 1,
          deposit_types: ['ordinary deposit'],
          product_types: ['fixed term deposit'],
          countries: [country.alpha2],
          terms: [12],
        },
      );

      const { data: twoYearsDepositsBestRate } = await getDepositsListRequest(
        locale || 'en',
        {
          is_test: false,
          page: 1,
          deposit_types: ['ordinary deposit'],
          product_types: ['fixed term deposit'],
          countries: [country.alpha2],
          terms: [24],
        },
      );

      const { data: threeYearsDepositsBestRate } = await getDepositsListRequest(
        locale || 'en',
        {
          is_test: false,
          page: 1,
          deposit_types: ['ordinary deposit'],
          product_types: ['fixed term deposit'],
          countries: [country.alpha2],
          terms: [36],
        },
      );

      const preparedBestRates: IRateInBestRatesProps[] = [
        oneYearDepositsBestRate[0],
        twoYearsDepositsBestRate[0],
        threeYearsDepositsBestRate[0],
      ]
        .filter((deposit) => deposit !== undefined)
        .map((deposit: any) => MapDepositsFromServer(deposit))
        .map((d): IRateInBestRatesProps => {
          return {
            rate: d.grossInterestRate,
            url: `/fixed-deposits/${COUNTRIES_PATHS[country!.name][locale || 'en']}/${termKeys[d.termMonths][locale || 'en']}/all`,
            term: d.termMonths,
            depositTypeKey: 'header.all_deposits',
            currency: d.currency,
          };
        });
      setFixedDeposits(preparedBestRates);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchRates();
  }, []);

  if (fixedDeposits.length > 0) {
    return (
      <div className="mt-6 w-full">
        <BestRatesList
          rates={fixedDeposits}
          className="bg-blue-50 md:bg-white"
          itemClassName="bg-white"
        />
      </div>
    );
  }
  return null;
};
